import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        data: {
            type: Object,
            default() {
                return {
                    title: '',
                    icon: '',
                    text: ''
                };
            }
        },
        height: {
            type: String
        },
        width: {
            type: String
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        showBorder: {
            type: Boolean,
            default: true
        }
    }
});
